<template>
    <SwapMenu2 :swapid="swapid" title="Setup" margin="1">
      <template v-slot:menu>
      <li> <a class="dropdown-item" @click="refresh()">Refresh</a> </li>
      <li v-if="showadduser"> 
         <a class="dropdown-item" @click="newuser('')">Add New User</a>
      </li>
      </template>
    </SwapMenu2>
    <div class="container divstyle">
        <div style='margin:auto;width:50%'>
          <input type="radio" id="radio1" @click="clickradio('dir')"
            value="dir">
          <label style='padding:10px' for="radio1">DIR</label>

          <input type="radio" id="radio2" @click="clickradio('file')"
            value="file">
          <label style='padding:10px' for="radio2">File</label>

          <input type="radio" id="radio3" @click="clickradio('both')"
            value="both" checked>
          <label style='padding:10px' for="radio3">Both</label>

        </div>

        <table class="table table-bordered table-striped font-custom">
            <thead class="headline">
                <tr class="tralign">
                    <th class=thx>FileName</th>
                    <th class=thx>Type</th>
                    <th class=thx>Size</th>
                    <th class=thx>DateTime</th>
                </tr>
            </thead>
            <tbody>
              <template v-for="data in filterlist" :key="data[0]"> 
              <tr v-show="selected.includes(data[1])" 
                  @click="doaction($event, data[0])">
                    <td class="colpad">{{data[0]}}</td>
                    <td class="colpad">{{data[1]}}</td>
                    <td class="colpad">{{data[2]}}</td>
                    <td class="colpad">{{data[3]}}</td>
              </tr>
              </template>
            </tbody>
        </table>
    </div>    
    <ErrorModal :swapid="swapid" modalid="ERRMODAL10"><p>{{errormsg}}</p></ErrorModal>

    <ShowModal  ref="MODALS01" modalid="MODALS01" :swapid="swapid" 
                    :script="filename">
        <div style='margin:auto;width:75%;font-size:10pt'>
            <br>

            <button style='padding:2px' type="button" 
              data-bs-dismiss="modal" 
              @click="action_view()">Edit</button>

            <button style='padding:2px;margin-left:10px' 
              type="button" data-bs-dismiss="modal" 
              @click="action_move()">Move</button>

            <button style='padding:2px;margin-left:10px' 
              type="button" data-bs-dismiss="modal" 
              @click="action_remove()">Remove</button>
          </div>
    </ShowModal>

    <UserModal ref="USERMODAL" modalid="USERMODAL" >
        <div style='margin:auto;width:5rem;font-size:10pt'>
            <button style='padding:2px;margin-left:10px' 
              type="button" data-bs-dismiss="modal" 
              @click="adduser()">Add</button>
        </div>
    </UserModal>
</template>

<style scoped>
.divstyle {
    font-size : 10pt ;
    max-height: 270px;
    overflow-y: auto;
    margin-top: 0px ;
}
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.thx {
   height : 12px ;
   padding : 0 ;
}

.myheadline {
    height: 14pt ;
    background : #5090FF ;
    padding : 0px;
    margin : 0px;
}

.tralign {
  height: 12px ;
  text-algin: left ;
}

.leftalign {
    float: left ;
}
tbody tr:hover {
  background-color: yellow;
  cursor: pointer ;
}

.colpad {
  padding: 2px !important ;
  font-size: 10pt ;
  text-align : left ;
  white-space: nowrap ;
  overflow : auto ;
}
.headline {
  background : #8080FF;
  color : white ;
}
</style>

<script>
import axios from 'axios'
import ErrorModal from './ErrorModal.vue'
import ShowModal from './ShowModal.vue'
import UserModal from './UserModal.vue'
import bootstrap from 'bootstrap/dist/js/bootstrap.js'
import SwapMenu2 from './SwapMenu2.vue' 
import sha256 from 'crypto-js/sha256' 
import Base64 from 'crypto-js/enc-base64' 

export default {
  name: 'SwapSetup',
  components: {
     ErrorModal, SwapMenu2, ShowModal, UserModal
  },
  watch : {
    swapid : function (newswap) {
      this.refresh();
      this.$parent.filepath = '' ;
      this.$parent.writearea ( 'Current Swap is ' + newswap ) ;
    }
  },
  props: {
    swapid : String
  },
  data() {
    return {
        filename : "",
        rowtarget: {},
        selected : "DIR FILE",
        currentdir: '', 
        dirlist : [ [ ".", "none", "none", "none" ] ],
        vmessage : "Please Click Entry below",
        errormsg : "Invalid Command" 
    }
  },
  computed : {
    showadduser() {
        return this.$store.getters.controllerid == this.swapid ;
    },
    filterlist() {
        if (this.dirlist.length <= 0)
           return [ [ ".", "none", "none", "none" ] ] ;
        return this.dirlist ;
    }
  },
  mounted() {
    this.getdirlist("") ;
    this.$parent.writearea ( 'Current Swap is ' + this.swapid) ;
  },
  methods : {
    action_remove() {
        this.removefile(this.swapid, this.currentdir + "/" + 
            this.rowtarget.data[0]) ;
    },
    action_move() {
        if (this.$refs.MODALS01.argument == "")
            return alert ("move need destination in ARG:") ;
        this.movefile(this.swapid, this.currentdir + "/" + 
            this.rowtarget.data[0],
                this.currentdir + "/" + this.$refs.MODALS01.argument) ;
    },
    action_view() {
        if (parseInt(this.rowtarget.data[2]) > 16 * 1024) 
            return this.showerror ("This Does not look like config file", 
                                this.rowtarget.X, this.rowtarget.Y) ; 
        this.getfile(this.swapid, this.currentdir + "/" + 
            this.rowtarget.data[0] ) ;
    },
    clickradio(xtype) {
        let myradio1 = document.getElementById( "radio1" ) ;
        let myradio2 = document.getElementById( "radio2" ) ;
        let myradio3 = document.getElementById( "radio3" ) ;
        
        if (xtype == "dir") {
            this.selected = "DIR" ;
            myradio2.checked = false ;
            myradio3.checked = false ;
        }
        else if (xtype == "file")  {
            this.selected = "FILE" ;
            myradio1.checked = false ;
            myradio3.checked = false ;
        }
        else {
            this.selected = "DIR FILE" ;
            myradio1.checked = false ;
            myradio2.checked = false ;
        }
    },
    refresh() {    // toggle start or stop swap
        this.getdirlist(this.currentdir);
    },
    getdirlist(newdir) {
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                  "/prosw/CFG/view" + newdir + "?swapid=" + this.swapid ;
        }
        catch(err) {
           console.log(err) ;
           return ;
        }
        axios.get (req, {
            timeout: 5000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           let myarray = [] ;

           if (newdir != "")  
               myarray.push ([ "..parent", "DIR", "0", "----------"])

           if (typeof response.data != "object") { 
               myarray.push ( [ "NOT JSON", "DIR", "ERROR", response.data.substr(0,15) ]) ;
               this.dirlist = myarray ;
               this.currentdir = this.currentdir + "/error" ;
               return ;
           }
           if (response.data.RC != "00") {
               myarray.push ( [ "RC :" + response.data.RC , "DIR", "ERROR", 
                                response.data.RDESC.substr(0,15) ]) ;
               this.dirlist = myarray ;
               this.currentdir = this.currentdir + "/error" ;
               return ;
           }

           let dirarr = response.data.RESULT ;
           for (let i in dirarr) {
             let dirobj = dirarr[i] ;
             let typex = dirobj.mode ;
             if (dirobj.mode == "40") 
                 typex = "DIR" ;
             else if (dirobj.mode == "100") 
                 typex = "FILE" ;
             else if (dirobj.mode == "104") 
                 typex = "FILE" ;
             myarray.push ([ dirobj.name,typex,dirobj.size,dirobj.mtime]) ;
           }
           this.dirlist = myarray ;
           this.currentdir = newdir ;
        }).catch ( (error) => { console.log(error) })
    },
    getAbsPosition(el) {
        let el2 = el;
        let curtop = 0;
        let curleft = 0;
        if (document.getElementById || document.all) {
            do  {
                curleft += el.offsetLeft-el.scrollLeft;
                curtop += el.offsetTop-el.scrollTop;
                el = el.offsetParent;
                el2 = el2.parentNode;
                while (el2 != el) {
                    curleft -= el2.scrollLeft;
                    curtop -= el2.scrollTop;
                    el2 = el2.parentNode;
                }
            } while (el.offsetParent);
        } else if (document.layers) {
            curtop += el.y;
            curleft += el.x;
        }
        return { 'top' : curtop, 'left' :  curleft } ;
    },
    showmodal() {
        let modalid = 'MODALS01' ;
        let divmodal = document.getElementById( modalid ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   (this.rowtarget.Y - 50) + 'px' ;
        divmodal.style.left =  (this.rowtarget.X + 20) + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    newuser(errormsg) {
        let divmodal = document.getElementById( "USERMODAL" ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   '100px' ;
        divmodal.style.left =  '20px' ;

        if (errormsg == "") {
            this.$refs.USERMODAL.userid = "" ;
            this.$refs.USERMODAL.password = "" ;
            this.$refs.USERMODAL.adminlvl = "" ;
            this.$refs.USERMODAL.errormsg = "" ;
        }
        else this.$refs.USERMODAL.errormsg = errormsg ;
        myModal.show() ;
        return 0 ;
    },
    adduser() {
        let userid = this.$refs.USERMODAL.userid ;
        let password = this.$refs.USERMODAL.password ;
        let adminlvl = this.$refs.USERMODAL.adminlvl;
        let multisession = this.$refs.USERMODAL.multisession;

        if (userid == "") 
            return this.newuser ("USERID can not blank!") ;

        if (password == "") 
            return this.newuser ("Pasword can not blank!") ;

        if (adminlvl < "0" || adminlvl > "2") 
            return this.newuser ("admin lvl must be 0, 1, or 2!") ;

        if (multisession < "0" || multisession > "1") 
            return this.newuser ("multisession must be 0, or 1!") ;
            
        let hashDigest = sha256( userid + password) ;
        let textDigest = Base64.stringify(hashDigest) ;

        let url = this.$store.getters.controller_url + 
                "/prosw/CFG/adduser?swapid="  + this.swapid ;
        let formData = new FormData();
        formData.append('user', userid) ;
        formData.append('password', textDigest) ;
        formData.append('admin', adminlvl) ;
        formData.append('multisession', multisession) ;

        axios.post (url, formData,
                    {  timeout : 5000, 
                       headers: {
                         'Pswtoken': this.$store.getters.pswtoken, 
                         'Content-Type': 'multipart/form-data' 
                       }
                    }
        ).then (response => {
                    let res = response.data ;
                    alert (res.RDESC) ;
        })
        .catch ( (error) => { alert (error) ; console.log(error); 
        }) ;
    },
    showerror(error, modalX, modalY) {
        let modalid = 'ERRMODAL10' ;
        let divmodal = document.getElementById( modalid ) ;
        let myModal = new bootstrap.Modal(
            document.getElementById(modalid), { backdrop : false }) ;
        this.errormsg = error;
        divmodal.style.top =  (modalY - 50) + 'px' ;
        divmodal.style.left = modalX + 20 + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    changedir (data, posX, posY) 
    {
        if (data[1] != "DIR") 
            return this.showerror("Data DIR can not cd", posX, posY) ; 

        let newdir = "" ;
        if (data[0] == "..parent") {
           let a = this.currentdir.lastIndexOf("/"); 
           if (a <= 0)
                    newdir = "" ;
           else {
                    newdir = this.currentdir.substring(0,a) ;
                    if (newdir == "/") newdir = "" ;
           }
       }
       else 
           newdir = this.currentdir + "/" + data[0] ;        
       this.getdirlist(newdir) ;
    },
    getfile(swapid, filename) {     
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/CFG/view?" + "swapid=" + swapid +
                "&filename=" + filename ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        this.sendreq(req) ;
        this.$parent.filepath = filename ;
    },
    movefile(swapid, filename, destfile) {     
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/CFG/move/" + filename + "?filename="  + destfile 
               + "&swapid=" + swapid ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        this.sendreq(req) ;
    },
    removefile(swapid, filename) {     
        let req = "" ;
        if (! confirm("Remove File ?")) return ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/CFG/remove/" + filename + "?" + "swapid=" + swapid ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        this.sendreq(req) ;
    },
    sendreq(req) {    
        axios.get (req,  {
           timeout: 5000,
           responseType: 'text', 
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
            let res = response.data ;
            if (typeof res == "object") 
                this.$parent.writearea (JSON.stringify(res))
            else 
                this.$parent.writearea (response.data);
            this.refresh();
       }).catch ( (error) => { 
            this.$parent.filepath = '';
            if (error.code === 'ECONNABORTED') {
                alert ("action failed " + error) ;
                console.log('Request timed out');
            } else {
                alert ("action failed " + error) ;
                console.log(error.message);
          }
       })
    },
    doaction(event, rowkey)
    {
        let rowdata = this.dirlist.find ( x => x[0] == rowkey) ;
        if (! rowdata) 
            return this.showerror( "Data not found", event.clientX, event.clientY) ; 
        if (rowdata[1] == "DIR") 
            this.changedir(rowdata, event.clientX, event.clientY)  ;
        else if (rowdata[1] == "FILE") {
            this.rowtarget = { "data" : rowdata, 
                    "X" : event.clientX, "Y" : event.clientY };
            this.filename = rowdata[0] ;
            this.$refs.MODALS01.argument = "" ;
            this.showmodal();
        }
        else
            return this.showerror( "Command Not Supported :" + this.selected, 
                        event.clientX, event.clientY) ; 
    }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>


